
import { defineComponent, ref, inject } from 'vue';

import {
  linkWithCredential, sendEmailVerification, EmailAuthProvider
} from 'firebase/auth';

import { useAuthFlow } from '@/auth-hooks';
import { errorHandler } from '../recent-handler';
import { ModalPayloadKey, ModalReason, UserDataKey } from '../types';

import PasswordField from '@/components/PasswordField.vue';

export default defineComponent({
  components: { PasswordField },
  setup() {
    const { user, refreshUser } = inject(UserDataKey)!;
    const modalPayload = inject(ModalPayloadKey)!;

    const email = ref("");
    const password1 = ref("");
    const password2 = ref("");
    const errors = ref<string[]>([]);

    const hidden = ref(true);

    const { authExecutor } = useAuthFlow({ errors, errorHandler });

    const validate = () => {
      errors.value = [];

      if (email.value.length == 0)
        errors.value.push("Please enter an email address.");

      if (password1.value.length == 0)
        errors.value.push("Please enter a password.");
      else if (password2.value.length == 0)
        errors.value.push("Please verify your password.");
      else if (password1.value != password2.value)
        errors.value.push("Those passwords do not match.");

      return errors.value.length == 0;
    }

    const submit = () => {
      if (!validate()) return;

      const execute = async () => {
        const cred = EmailAuthProvider.credential(email.value, password1.value);

        const success = await authExecutor(linkWithCredential(
          user.value,
          cred
        ));

        if (success) {
          await sendEmailVerification(user.value);
          refreshUser();
          modalPayload.value = null;
        }
      }

      execute().catch(() => {
        modalPayload.value = {
          reason: ModalReason.Reauthorize,
          callback: execute
        }
      });
    }

    return {
      email, password1, password2, errors, hidden, submit, modalPayload
    };
  }
});
